import { SelectOption } from '../SelectOption/SelectOption';

const ActivityTypeCodes = {
    1: 'Log In',
    2: 'Log Out',
    3: 'Modify User Request',
    4: 'Modify Firm Request',
    5: 'Modify Firm Account Request',
    6: 'Add Address Book Record Request',
    7: 'Modify Address Book Record Request',
    8: 'Delete Address Book Record Request',
    11: 'Send Request',
    12: 'Add Firm Request',
    13: 'Close Firm Request',
    14: 'Add Client User Request',
    15: 'Delete Client User Request',
    16: 'User Locked From All Accounts',
    17: 'User Unlocked From All Accounts',
    20: 'User frozen for all linked accounts',
    21: 'User unfrozen for all linked accounts',
    22: 'Password Reset',
    23: 'All Accounts in Firm Locked',
    24: 'All Accounts in Firm Unlocked',
    25: 'All Accounts in Firm Frozen',
    26: 'All Accounts in Firm Unfrozen',
    27: 'Add New Account Request',
    28: 'Account Locked from all users',
    29: 'Account Unlocked for all users',
    32: 'Account Closed',
    33: 'Firm enabled for Token API Use',
    34: 'Firm disabled for Token API Use',
    35: 'User enabled for Token API Use',
    36: 'User disabled for Token API Use',
    37: 'User paired to API Connection',
    38: 'User linked to a account',
    39: 'User role within a account modified',
    40: 'User link to account deleted',
    41: 'New API Connection Added Request',
    42: 'API Connection disabled from use',
    43: 'API Connection re-enabled for use',
    44: 'API Connection Deleted',
    45: 'User locked from using API Connection',
    46: 'User Re-enabled to use API Connection',
    47: 'User link to API connection deleted',
    48: 'Firm locked from using API Connection',
    49: 'Firm re-enabled to use API Connection',
    50: 'Add/delete a ACG number to a account',
    51: 'Create a ACG number',
    52: 'Link a ACG Number to a user',
    53: 'Unlink a ACG number from a user',
    54: 'Delete a ACG number',
    55: 'Admin user login failure',
    56: 'Client user login failure',
    57: 'Admin user locked',
    58: 'Admin user unlocked',
    59: 'Add Admin User Request',
    62: 'Send Confirmed',
    63: 'Admin user role modified',
    64: 'Modify admin user request',
    65: 'Failed deposit',
    67: 'Failed Send',
    69: 'Account creation failure',
    70: 'Firm creation failure',
    71: 'Firm modify failure',
    72: 'Account Modification Failure',
    73: 'Client user modify failure',
    74: 'Session timed out',
    83: 'Excessive login attempts',
    84: 'Admin excessive login attempts',
    85: 'Client user creation failed',
    86: 'Reopen Firm Request',
    87: 'Reopen Account Request',
    90: 'Send Request Approved',
    91: 'Send Request Declined',
    94: 'Client Notification Message Created',
    95: 'Client Notification Message Approved',
    96: 'Client Notification Message Declined',
    97: 'Client Notification Message Canceled',
    98: 'Client Notification Message Updated',
    99: 'Client Notification Message Ended',
    100: 'Admin User Deleted',
    300: 'Withdrawal Requested',
    302: 'Buy Order Canceled',
    303: 'Sell Order Canceled',
    306: 'Buy Order Requested',
    307: 'Sell Order Requested',
    308: 'Generate New API Key',
    309: 'Deleted API Key',
    310: 'Subscription Order Requested',
    311: 'Redemption Order Requested',
    312: 'Subscription Order Canceled',
    313: 'Redemption Order Canceled',
    330: 'New Collateral Post',
    331: 'Collateral Post Add On',
    332: 'Collateral Reclaimed',
    333: 'Collateral Partially Reclaimed',
    334: 'Collateral Released',
    335: 'Collateral Partially Released'
};

const caseInsensitiveSort = (valueA: string, valueB: string): number => {
    // if value is not defined push to end of array for A or B
    if (!valueA) return 1;
    if (!valueB) return -1;

    return valueA.toLowerCase()
        .localeCompare(valueB.toLowerCase());
};

export const getActivityTypeCodeSelectOptions = (): SelectOption[] => {
    const options = Object
        .keys(ActivityTypeCodes)
        .map((code) => ({
            label: ActivityTypeCodes[code],
            value: code
        }))
        .sort((optionA, optionB) => caseInsensitiveSort(optionA.label, optionB.label));

    options.unshift({
        label: 'Select an option...',
        value: ''
    });

    return options;
};

export const ActivityTypeSelectOptions = getActivityTypeCodeSelectOptions();

export default ActivityTypeCodes;